/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketplace_Seo_Spain_Meta_DescriptionInputs */

const es_marketplace_seo_spain_meta_description = /** @type {(inputs: Marketplace_Seo_Spain_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alquiler de veleros y barcos a motor en España: con o sin patrón, barcos sin licencia y excursiones en barco. Reserva con armadores locales en Zarpar.`)
};

const gl_marketplace_seo_spain_meta_description = /** @type {(inputs: Marketplace_Seo_Spain_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alugueiro de veleiros e barcos a motor en España: con ou sen patrón, barcos sen licenza e excursiones en barco. Reserva con armadores locais en Zarpar.`)
};

const en_marketplace_seo_spain_meta_description = /** @type {(inputs: Marketplace_Seo_Spain_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rent sailboats and motorboats in Spain: with or without skipper, licence-free boats and day trips. Book with local owners on Zarpar.`)
};

/**
* | output |
* | --- |
* | "Rent sailboats and motorboats in Spain: with or without skipper, licence-free boats and day trips. Book with local owners on Zarpar." |
*
* @param {Marketplace_Seo_Spain_Meta_DescriptionInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const marketplace_seo_spain_meta_description = /** @type {((inputs?: Marketplace_Seo_Spain_Meta_DescriptionInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketplace_Seo_Spain_Meta_DescriptionInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_marketplace_seo_spain_meta_description(inputs)
	if (locale === "en") return en_marketplace_seo_spain_meta_description(inputs)
	return es_marketplace_seo_spain_meta_description(inputs)
});